var PREFIX = "HOTKEYS.";
// export const SET_MENU_BAR_HOTKEYS = PREFIX + "SET_MENU_BAR_HOTKEYS";
// export const STORE_PROJECT_EDITOR_KEYBOARD_CALLBACKS =
//     PREFIX + "STORE_PROJECT_EDITOR_KEYBOARD_CALLBACKS";
// export const STORE_EDITOR_KEYBOARD_CALLBACKS =
//     PREFIX + "STORE_EDITOR_KEYBOARD_CALLBACKS";
export var UPDATE_COUNTER = PREFIX + "UPDATE_COUNTER";
